import Gallery from '../components/Gallery';

function Home() {
  return (
        <Gallery/>
  )
}

export default Home